<template>
    <AppHeaderDropdown no-caret>
        <template slot="header">
            {{ $t('header.hello', { name: splitName(currentUser.name) }) }}
            <avatar
                class="align-middle m-2"
                :src="currentUser.picture"
                :username="currentUser.name"
                inline
                :size="35"
            />
        </template>
        <template slot="dropdown">
            <b-dropdown-item @click.stop="profile()">
                <i class="cui-user" />
                {{ $t('header.profile') }}
            </b-dropdown-item>
            <b-dropdown-item @click.stop="settings()">
                <i class="cui-settings" />
                {{ $t('header.settings') }}
            </b-dropdown-item>
            <b-dropdown-item @click.native.capture.stop="collapseLanguage()">
                <i class="cui-globe" />
                {{ $t('header.language') }}
                <i
                    class="pull-right mt-1 fa"
                    v-bind:class="[isLanguageCollapsed ? 'fa-chevron-up' : 'fa-chevron-down']"
                ></i>
            </b-dropdown-item>
            <span v-show="isLanguageCollapsed">
                <b-dropdown-item :active="languageSelected == 'pt-BR'" @click="setLanguage('pt-BR')">
                    <span class="ml-4">{{ $t('header.availableLanguages.pt-BR') }}</span>
                </b-dropdown-item>
                <b-dropdown-item :active="languageSelected == 'en-US'" @click="setLanguage('en-US')">
                    <span class="ml-4">{{ $t('header.availableLanguages.en-US') }}</span>
                </b-dropdown-item>
                <b-dropdown-item :active="languageSelected == 'es-ES'" @click="setLanguage('es-ES')">
                    <span class="ml-4">{{ $t('header.availableLanguages.es-ES') }}</span>
                </b-dropdown-item>
            </span>
            <b-dropdown-item @click.stop="logout()">
                <i class="cui-account-logout" />
                {{ $t('header.logout') }}
            </b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
import Avatar from 'vue-avatar'
import api from '@/services/api'
import oauth from '@/services/oauth-api'
import AuthService from '@/services/auth'
import { getOrigin } from '@/lib/url'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { getUserPermissions } from '@/services/user-permissions'
import { systemLocaleMixin } from '@/mixins'

export default {
    name: 'DefaultHeaderDropdown',
    mixins: [systemLocaleMixin],
    components: {
        AppHeaderDropdown,
        Avatar,
    },
    props: ['currentUser'],
    data() {
        return {
            origin: getOrigin(),
            currentUserPermissions: getUserPermissions(),
            isLanguageCollapsed: false,
            languageSelected: localStorage.getItem('NG_TRANSLATE_LANG_KEY'),
            loading: false,
        }
    },
    computed: {
        authService() {
            return AuthService(api, oauth)
        },
    },
    methods: {
        profile() {
            this.$router.push({
                path: `/v2/profile/${this.currentUser.id}`,
            })
        },
        settings() {
            window.location.href = `${this.origin}/app/users/current/edit`
        },
        language() {
            window.location.href = `${this.origin}/app/users/current/edit`
        },
        collapseLanguage() {
            this.isLanguageCollapsed = !this.isLanguageCollapsed
        },
        setLanguage(language) {
            if (!this.loading) {
                this.setSystemCurrentLocale(language)
                this.languageSelected = language
                this.collapseLanguage()
                api.put(`/users/${this.currentUser.id}/set-user-language`, {
                    language: language,
                }).then(() => {
                    this.loading = false
                })
            }
        },
        logout() {
            this.authService.logout()
        },
        splitName(name) {
            return name.split(' ')[0]
        },
    },
}
</script>
